import clsx from "clsx";
import type { MouseEvent } from "react";

import { TRACK_CHEVRON_MOTION_CLASS } from "./constants";

type DubbingTrackChevronProps = {
  isLanguageTrackActive: boolean;
  label: string;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
};

export function DubbingTrackChevron({ className, isLanguageTrackActive, label, onClick }: DubbingTrackChevronProps) {
  return (
    <button
      type='button'
      aria-label={label}
      aria-pressed={isLanguageTrackActive}
      title={label}
      className={clsx(
        "tw-flex tw-size-6 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-transparent tw-p-0 tw-text-white tw-outline-none focus-visible:tw-outline-focus",
        className,
      )}
      onClick={onClick}
    >
      <svg
        viewBox='0 0 24 24'
        fill='none'
        aria-hidden='true'
        className='tw-size-6 tw-rotate-[-90deg] tw-overflow-visible'
      >
        <path
          d='M8 10L12 14'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          vectorEffect='non-scaling-stroke'
          className={clsx(
            "tw-transition-transform",
            TRACK_CHEVRON_MOTION_CLASS,
            isLanguageTrackActive && "tw-rotate-[-90deg]",
          )}
          style={{ transformBox: "fill-box", transformOrigin: "center" }}
        />
        <path
          d='M16 10L12 14'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          vectorEffect='non-scaling-stroke'
          className={clsx(
            "tw-transition-transform",
            TRACK_CHEVRON_MOTION_CLASS,
            isLanguageTrackActive && "tw-rotate-90",
          )}
          style={{ transformBox: "fill-box", transformOrigin: "center" }}
        />
      </svg>
    </button>
  );
}
